import axios from "axios";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SignatureImage from "../assets/images/9705b85baa92bcc6ac85822185369656.png";
import { frontendAppUrl, frontendBaseUrl, serverBaseUrl } from "../config/envs";
import { REMOVE_SIGNATURE } from "../redux/actions/actionTypes";
import {
  UPDATE_MD_FORM,
  UPDATE_MD_FORM_ERROR,
} from "../redux/actions/formActions";
import { isWhitespaceString } from "../utils/regex";
import { sendSuccessToast, showErrorToast } from "../utils/toast";
import CustomButton from "./Button";
import SignatureComponent from "./Signature";

const RXForm = ({
  data,
  isFirstSign,
  setSignType,
  setSignImages,
  signImages,
  handleOnSignatureClick,
  filledSignatureIds,
  setFilledSignatureIds,
  handleOnSignatureChange,
}) => {
  const { signSecretId } = useParams();
  const dispatch = useDispatch();
  const mdFormData = useSelector((state) => state?.form?.mdForm);
  const mdFormErrors = useSelector((state) => state?.form?.mdFormErrors);
  const [isMD, setIsMD] = useState(false);

  const singnerData = useSelector((state) => state?.signature?.signerData);
  const signature = useSelector((state) => state?.signature);
  const { signedDoc, loading } = signature;
  let currentIndex = 0;

  const removeSignature = async () => {
    let _payLoad = {
      signerId: isMD ? data?.data?.signers[1]?.id : data?.data?.signers[0]?.id,
      clinicId: data?.data?.qualiphy_clinic_id,
      signSecretId: signSecretId,
    };
    dispatch({
      type: REMOVE_SIGNATURE,
      payload: _payLoad,
    });
    if (isMD) {
      const removeFromAll = filledSignatureIds.filter(
        (id) => id !== "md_signature_1" && id !== "md_signature_2"
      );
      setFilledSignatureIds(removeFromAll);
      setSignImages({
        ...signImages,
        medicalDirectorSignature: null,
      });
    } else {
      const removeFromAll = filledSignatureIds.filter(
        (id) =>
          id !== "signature_1" && id !== "signature_2" && id !== "signature_3"
      );
      setFilledSignatureIds(removeFromAll);
      setSignImages({
        ...signImages,
        adminPracticeSign: null,
      });
    }
  };

  useEffect(() => {
    if (data?.data?.status === 1) {
      setIsMD(true);
    } else {
      setIsMD(false);
    }
  }, [data]);

  const [currentDate, setCurrentDate] = useState(
    `${new Date().toLocaleDateString("en-US")} ${new Date().toLocaleTimeString(
      "en-US"
    )}`
  );

  const handleChangeMDForm = (e) => {
    dispatch({
      type: UPDATE_MD_FORM,
      payload: { key: e.target.name, value: e.target.value },
    });
  };

  const handleChangeError = (key, value) => {
    dispatch({
      type: UPDATE_MD_FORM_ERROR,
      payload: { key, value },
    });
  };

  useEffect(() => {
    dispatch({
      type: UPDATE_MD_FORM,
      payload: {
        key: "md_title",
        value: "Medical Director",
      },
    });
    dispatch({
      type: UPDATE_MD_FORM,
      payload: {
        key: "admin_title",
        value: "Authorized Signatory",
      },
    });
  }, []);
  useEffect(() => {
    if (data?.data?.qualiphy_clinic_name) {
      dispatch({
        type: UPDATE_MD_FORM,
        payload: {
          key: "name_of_practice",
          value: data?.data?.qualiphy_clinic_name,
        },
      });
    }
    if (!isMD && data?.data?.signers[0]?.name) {
      dispatch({
        type: UPDATE_MD_FORM,
        payload: {
          key: "admin_name",
          value: data?.data?.signers[0]?.name,
        },
      });
    }
    if (isMD && data?.data?.signers[0]?.name) {
      dispatch({
        type: UPDATE_MD_FORM,
        payload: {
          key: "admin_title",
          value: data?.data?.signers[0]?.title,
        },
      });
      dispatch({
        type: UPDATE_MD_FORM,
        payload: {
          key: "admin_sign_date",
          value: moment(
            data?.data?.signers[0]?.date_signed,
            "MM-DD-YYYY hh:mm"
          ).format("MM/DD/YYYY hh:mm"),
        },
      });
      console.log(
        "admin_sign_date: ",
        moment(data?.data?.signers[0]?.date_signed, "MM-DD-YYYY").format(
          "MM/DD/YYYY"
        )
      );
    }

    if (isMD && data?.data?.signers[1]?.name) {
      dispatch({
        type: UPDATE_MD_FORM,
        payload: {
          key: "md_name",
          value: data?.data?.signers[1]?.name,
        },
      });
    }
  }, [data, dispatch, isMD]);

  useEffect(() => {
    if (
      mdFormErrors &&
      Object.entries(mdFormErrors).filter(([key, value]) => value != null)
        .length
    ) {
      // scroll to the first error
      const firstError = Object.keys(mdFormErrors)[0];
      const element = document.getElementById(firstError);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [mdFormErrors]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = useCallback(async () => {
    if (isFirstSign) return;

    if (!isMD) {
      if (!filledSignatureIds.includes("signature_1")) {
        handleChangeError("signature_1", "Please sign the document");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("signature_1", null);
      }

      if (!filledSignatureIds.includes("signature_2")) {
        handleChangeError("signature_2", "Please sign the document");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("signature_2", null);
      }

      if (!filledSignatureIds.includes("signature_3")) {
        handleChangeError("signature_3", "Please sign the document");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("signature_3", null);
      }

      if (
        !mdFormData?.name_of_practice ||
        isWhitespaceString(mdFormData?.name_of_practice)
      ) {
        handleChangeError(
          "name_of_practice",
          "Please enter your name of practice"
        );
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("name_of_practice", null);
      }
      if (
        !mdFormData?.admin_name ||
        isWhitespaceString(mdFormData?.admin_name)
      ) {
        handleChangeError("admin_name", "Please enter your name");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("admin_name", null);
      }
      if (
        !mdFormData?.admin_title ||
        isWhitespaceString(mdFormData?.admin_title)
      ) {
        handleChangeError("admin_title", "Please enter your title");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("admin_title", null);
      }
    } else {
      if (!filledSignatureIds.includes("md_signature_1")) {
        handleChangeError("md_signature_1", "Please sign the document");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("md_signature_1", null);
      }
      if (!filledSignatureIds.includes("md_signature_2")) {
        handleChangeError("md_signature_2", "Please sign the document");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("md_signature_2", null);
      }

      if (!mdFormData?.md_name || isWhitespaceString(mdFormData?.md_name)) {
        handleChangeError("md_name", "Please enter your name");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("md_name", null);
      }
      if (!mdFormData?.md_title || isWhitespaceString(mdFormData?.md_title)) {
        handleChangeError("md_title", "Please enter your title");
        showErrorToast("Please fill all the required fields");
        return;
      } else {
        handleChangeError("md_title", null);
      }
    }
    setSubmitLoading(true);
    const formData = new FormData();
    formData.append("qualiphy_clinic_id", data?.data?.qualiphy_clinic_id);
    formData.append("sign_link_id", data?.data?.signers[0]?.sign_link_id);
    formData.append("sign_secret_id", data?.data?.sign_secret_id);
    formData.append("document_type", "2");
    formData.append(
      "signer_id",
      isMD ? data?.data?.signers[1]?.id : data?.data?.signers[0]?.id
    );
    formData.append("sign_link", data?.data?.sign_link);
    formData.append("clinic_name", mdFormData?.name_of_practice?.trim());
    formData.append("qualiphy_title", "Qualiphy PC");
    formData.append("date", moment(currentDate).format("MM-DD-YYYY"));

    formData.append("admin_signature", signImages.adminPracticeSign);
    formData.append("admin_name", mdFormData?.admin_name?.trim());
    formData.append("admin_title", mdFormData?.admin_title?.trim());
    formData.append(
      "admin_sign_date",
      moment(currentDate).format("MM-DD-YYYY hh:mm")
    );

    if (isMD) {
      formData.append("md_signature", signImages.medicalDirectorSignature);
      formData.append("md_name", mdFormData?.md_name?.trim());
      formData.append("md_title", mdFormData?.md_title?.trim());
      formData.append(
        "md_sign_date",
        moment(isMD ? data?.data?.signers[0]?.date_signed : currentDate).format(
          "MM-DD-YYYY"
        )
      );
    }

    try {
      const response = await axios.post(
        `${serverBaseUrl}/submit_document`,
        formData,

        {
          headers: {
            "sign-secret-id": signSecretId,
          },
        }
      );

      if (response?.data?.success === true) {
        if (isMD) {
          sendSuccessToast("Thank you for signing the document");
          window.location.href = `${frontendBaseUrl}thank-you`;
        } else {
          window.location.href = `${frontendAppUrl}verify-sign?clinic_id=${data?.data?.qualiphy_clinic_id}&is_rx=true`;
        }
      } else {
        showErrorToast("Something went wrong, please try again later");
      }
    } catch (err) {
      showErrorToast("Something went wrong, please try again later");
      console.log(err);
    } finally {
      setSubmitLoading(false);
    }
  }, [singnerData, mdFormData, filledSignatureIds]);

  return (
    <div className="my-4">
      <div className="w-full px-4 flex flex-col md:flex-row justify-between gap-4">
        <div className="w-1/2 flex flex-col gap-2">
          {!isFirstSign ? (
            <p className="text-justify mb-1.5">
              <span className="font-serif text-base">
                (“Business Associate”)
              </span>
            </p>
          ) : (
            <></>
          )}
          <b>Qualiphy PC: </b>
          <div>
            <img
              src={SignatureImage}
              name="Image2"
              align="left"
              width={200}
              height={50}
              border={0}
              className="mb-2" // Optional: Adds margin-bottom to create space between image and border
            />
          </div>

          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              By:
            </label>
            Robert Vichich, M.D.
          </div>

          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Title:
            </label>
            President
          </div>
          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Date:
            </label>
            {currentDate}
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <p className="text-justify mb-1.5">
            <span className="font-serif  text-base">
              {!isFirstSign ? (
                <>(“Covered Entity”)</>
              ) : (
                <>
                  <b>PRACTICE</b>
                </>
              )}
            </span>
          </p>
          <div
            id={isFirstSign ? "signature" : "signature3"}
            className="flex flex-col gap-3 western mb-4"
          >
            <div className="w-full">
              <label
                htmlFor="date-signed"
                className="block font-bold mb-2 truncate"
              >
                Name of Practice:
              </label>
              <input
                type="text"
                id={isFirstSign ? "name_of_practice_1" : "name_of_practice_3"}
                name="name_of_practice"
                value={mdFormData?.name_of_practice}
                onChange={(e) => handleChangeMDForm(e)}
                className="border border-gray-300 rounded p-2 w-full "
                disabled={isMD}
              />
              {
                mdFormErrors?.name_of_practice && (
                  <span className="text-red-500 text-sm error-message">
                    {mdFormErrors?.name_of_practice}
                  </span>
                ) // Optional: Display error message if name_of_practice is empty
              }
            </div>
            <div className="w-full">
              {signImages.adminPracticeSign &&
              filledSignatureIds.includes(
                isFirstSign ? "signature_1" : "signature_3"
              ) ? (
                <SignatureComponent
                  allButtonIds={[
                    "signature_1",
                    "signature_2",
                    "signature_3",
                    "submit",
                  ]}
                  handleOnSignatureClick={() =>
                    handleOnSignatureClick({
                      type: "adminPracticeSign",
                      fillId: isFirstSign ? "signature_1" : "signature_3",
                    })
                  }
                  loading={loading}
                  removeSignatures={removeSignature}
                  userSignauter={signImages.adminPracticeSign}
                  id={isFirstSign ? "signature_1" : "signature_3"}
                  onChange={() =>
                    handleOnSignatureChange({
                      type: "adminPracticeSign",
                      fillId: isFirstSign ? "signature_1" : "signature_3",
                    })
                  }
                  disabled={isMD}
                />
              ) : null}
              {!signImages.adminPracticeSign ||
              !filledSignatureIds.includes(
                isFirstSign ? "signature_1" : "signature_3"
              ) ? (
                <CustomButton
                  disabled={isMD}
                  id={isFirstSign ? "signature_1" : "signature_3"}
                  className="px-4"
                  labelColor="black"
                  label="Sign"
                  onClick={() =>
                    handleOnSignatureClick({
                      type: "adminPracticeSign",
                      fillId: isFirstSign ? "signature_1" : "signature_3",
                    })
                  }
                />
              ) : null}
              {
                isFirstSign && mdFormErrors?.signature_1 && (
                  <span className="text-red-500 text-sm error-message">
                    {mdFormErrors?.signature_1}
                  </span>
                ) // Optional: Display error message if signature is empty
              }
              {
                !isFirstSign && mdFormErrors?.signature_3 && (
                  <span className="text-red-500 text-sm error-message">
                    {mdFormErrors?.signature_3}
                  </span>
                ) // Optional: Display error message if signature is empty
              }
            </div>
          </div>

          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              By:
            </label>
            <input
              disabled={isMD}
              type="text"
              id={isFirstSign ? "admin_name_1" : "admin_name_3"}
              name="admin_name"
              value={mdFormData?.admin_name}
              onChange={(e) => handleChangeMDForm(e)}
              className="border border-gray-300 rounded p-2 w-full "
            />
            {
              mdFormErrors?.admin_name && (
                <span className="text-red-500 text-sm error-message">
                  {mdFormErrors?.admin_name}
                </span>
              ) // Optional: Display error message if admin_name is empty
            }
          </div>
          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Title:
            </label>
            <input
              type="text"
              id={isFirstSign ? "admin_title_1" : "admin_title_3"}
              name="admin_title"
              disabled={isMD}
              value={mdFormData?.admin_title}
              onChange={(e) => handleChangeMDForm(e)}
              className="border border-gray-300 rounded p-2 w-full "
            />
            {
              mdFormErrors?.admin_title && (
                <span className="text-red-500 text-sm error-message">
                  {mdFormErrors?.admin_title}
                </span>
              ) // Optional: Display error message if title is empty
            }
          </div>
          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Date Signed:
            </label>
            <input
              type="text"
              id="date-signed"
              name="date-signed"
              value={isMD ? mdFormData?.admin_sign_date : currentDate}
              disabled
              className="border border-gray-300 rounded p-2 w-full "
            />
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/2 mt-4">
        <p className="text-justify mb-1.5">
          <span className="font-serif  text-base">
            <b>MEDICAL DIRECTOR</b>
          </span>
        </p>
        <div className="flex flex-col gap-3 western mb-4">
          <div className="w-full">
            {signImages.medicalDirectorSignature &&
            filledSignatureIds.includes(
              isFirstSign ? "md_signature_1" : "md_signature_2"
            ) ? (
              <SignatureComponent
                allButtonIds={["md_signature_1", "md_signature_2", "submit"]}
                handleOnSignatureClick={() =>
                  handleOnSignatureClick({
                    type: "medicalDirectorSignature",
                    fillId: isFirstSign ? "md_signature_1" : "md_signature_2",
                  })
                }
                onChange={() =>
                  handleOnSignatureChange({
                    type: "medicalDirectorSignature",
                    fillId: isFirstSign ? "md_signature_1" : "md_signature_2",
                  })
                }
                loading={loading}
                removeSignatures={removeSignature}
                userSignauter={signImages.medicalDirectorSignature}
                id={isFirstSign ? "md_signature_1" : "md_signature_2"}
              />
            ) : null}
            {!signImages.medicalDirectorSignature ||
            !filledSignatureIds.includes(
              isFirstSign ? "md_signature_1" : "md_signature_2"
            ) ? (
              <CustomButton
                disabled={!isMD}
                className="px-4"
                labelColor="black"
                id={isFirstSign ? "md_signature_1" : "md_signature_2"}
                label="Sign"
                onClick={() =>
                  handleOnSignatureClick({
                    type: "medicalDirectorSignature",
                    fillId: isFirstSign ? "md_signature_1" : "md_signature_2",
                  })
                }
              />
            ) : null}
            {
              isFirstSign && mdFormErrors?.md_signature_1 && (
                <span className="text-red-500 text-sm error-message">
                  {mdFormErrors?.md_signature_1}
                </span>
              ) // Optional: Display error message if signature is empty
            }
            {
              !isFirstSign && mdFormErrors?.md_signature_2 && (
                <span className="text-red-500 text-sm error-message">
                  {mdFormErrors?.md_signature_2}
                </span>
              ) // Optional: Display error message if signature is empty
            }
          </div>
          (Signature of Medical Director)
        </div>
        <div className="western text-justify">
          <label htmlFor="date-signed" className="block font-bold mb-2">
            By:
          </label>
          <input
            disabled={!isMD}
            type="text"
            id={isFirstSign ? "md_name_1" : "md_name_2"}
            name="md_name"
            value={mdFormData?.md_name}
            onChange={(e) => handleChangeMDForm(e)}
            className="border border-gray-300 rounded p-2 w-full "
          />
          {
            mdFormErrors?.md_name && (
              <span className="text-red-500 text-sm error-message">
                {mdFormErrors?.md_name}
              </span>
            ) // Optional: Display error message if md_name is empty
          }
        </div>
        <div className="western text-justify">
          <label htmlFor="date-signed" className="block font-bold mb-2">
            Title:
          </label>
          <input
            disabled={!isMD}
            type="text"
            id={isFirstSign ? "md_title_1" : "md_title_2"}
            name="md_title"
            value={mdFormData?.md_title}
            onChange={(e) => handleChangeMDForm(e)}
            className="border border-gray-300 rounded p-2 w-full "
          />
          {
            mdFormErrors?.md_title && (
              <span className="text-red-500 text-sm error-message">
                {mdFormErrors?.md_title}
              </span>
            ) // Optional: Display error message if title is empty
          }
        </div>
        <div className="western text-justify">
          <label htmlFor="date-signed" className="block font-bold mb-2">
            Date Signed:
          </label>
          <input
            type="text"
            id="date-signed"
            name="date-signed"
            value={currentDate}
            disabled
            className="border border-gray-300 rounded p-2 w-full "
          />
        </div>
      </div>
      {!isFirstSign ? (
        <div className="w-full flex justify-end mt-4">
          <CustomButton
            label="Submit"
            labelColor="black"
            backgroundColor={"rgb(207 201 255)"}
            className="w-full sm:w-auto"
            onClick={handleSubmit}
            // id="submit"
            isLoading={submitLoading}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RXForm;
